// News/event filter: apply a selection right away, the submit button is only needed without JS
export function initFilter() {
    document.querySelectorAll('.filter').forEach((form) => {
        form.classList.add('filter--auto');
        form.querySelectorAll('.filter_select').forEach((select) => {
            select.addEventListener('change', () => form.submit());
        });
    });
}
